<template>
  <b-row>
    <b-col cols="12">
      <industry-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import IndustryContent from './IndustryContent.vue'

export default {
  components: {
    BRow,
    BCol,

    IndustryContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>